<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>挂号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userkey" placeholder="输入姓名/科室"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="patient_realname" align="center" label="姓名" width="100">
      </el-table-column>
      <el-table-column align="center" label="挂号类型" width="100">
        <template slot-scope="scope">
            <div v-if="scope.row.type == 1">当日挂号</div>
            <div v-if="scope.row.type == 2">预约挂号</div>
        </template>
      </el-table-column>
      <el-table-column prop="reservation_date" align="center" label="预约日期" width="160">
      </el-table-column>
      <el-table-column prop="doctor_name" align="center" label="挂号医生" width="100">
      </el-table-column>
      <el-table-column prop="department_name" align="center" label="挂号科室" width="100">
      </el-table-column>
      <el-table-column prop="mzhm" align="center" label="门诊号码" width="160">
      </el-table-column>
      <el-table-column prop="createtime" label="挂号时间">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { registrationList } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10
        },
        listData: [], //表格数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(param) {
        registrationList(param)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      // 重置搜索
      formReset() {
        this.formInline.userkey = '';
      }
    }

  }
</script>

<style>
  .user-search {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/base/Registration.vue